module.exports = __webpack_public_path__ + "static/img/扬沙-右下.997da6d3.svg";